export default __webpack_public_path__ + "static/media/plan_parter.e91d2475.jpeg";